<template>
  <div class="w-full flex flex-col items-center">
    <div class="vx-col w-full md:w-2/3 m-4 text-center p-5">
      <div class="flex">
        <div class="w-1/4 px-2">
          <vs-card class="">
            <div class="text-3xl font-semibold py-3">{{ totalToday }}</div>
            <div class="text-xl">Hari ini</div>
          </vs-card>
        </div>
        <div class="w-1/4 px-2">
          <vs-card class="">
            <div class="text-3xl font-semibold py-3">{{ totalMonth }}</div>
            <div class="text-xl">Bulan ini</div>
          </vs-card>
        </div>
        <div class="w-1/4 px-2">
          <vs-card class="">
            <div class="text-3xl font-semibold py-3">{{ totalYear }}</div>
            <div class="text-xl">Tahun ini</div>
          </vs-card>
        </div>
        <div class="w-1/4 px-2">
          <vs-card class="">
            <div class="text-3xl font-semibold py-3">{{ totalAll }}</div>
            <div class="text-xl">Total</div>
          </vs-card>
        </div>
      </div>
      <div class="flex px-2">
        <vs-card>
          <div slot="header">
            <div class="vx-row text-left m-2">
              <h3 class="w-full text-left">List Pakta Integritas</h3>
            </div>
          </div>
          <table class="w-full text-left">
            <thead>
              <tr>
                <th>No</th>
                <th>Nama</th>
                <th>Status</th>
                <th>Tanggal</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(list, index) in lists" :key="index">
                <td class="px-3">{{ index + 1 }}</td>
                <td class="px-3">{{ list.name }}</td>
                <td>
                  <vs-chip class="ml-auto" color="success">Setuju</vs-chip>
                </td>
                <td class="px-3">{{ list.created_at | format }}</td>
              </tr>
            </tbody>
          </table>
        </vs-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      totalAll: 0,
      totalMonth: 0,
      totalYear: 0,
      totalToday: 0,
      lists: {},
      loading: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fetchTotalAll();
      this.fetchTotalToday();
      this.fetchTotalMonth();
      this.fetchTotalYear();
      this.fetchLists();
    },
    fetchTotalAll() {
      this.$http
        .get(`/app/general/integrity-pact/count`, {
          params: { filter: "all" },
        })
        .then((r) => {
          this.loading = false;
          this.totalAll = r.data.data.total;
        })
        .catch((e) => {
          this.loading = false;
          this.parseError(e);
        });
    },
    fetchTotalToday() {
      this.$http
        .get(`/app/general/integrity-pact/count`, {
          params: { filter: "today" },
        })
        .then((r) => {
          this.loading = false;
          this.totalToday = r.data.data.total;
        })
        .catch((e) => {
          this.loading = false;
          this.parseError(e);
        });
    },
    fetchTotalMonth() {
      this.$http
        .get(`/app/general/integrity-pact/count`, {
          params: { filter: "this_month" },
        })
        .then((r) => {
          this.loading = false;
          this.totalMonth = r.data.data.total;
        })
        .catch((e) => {
          this.loading = false;
          this.parseError(e);
        });
    },
    fetchTotalYear() {
      this.$http
        .get(`/app/general/integrity-pact/count`, {
          params: { filter: "this_year" },
        })
        .then((r) => {
          this.loading = false;
          this.totalYear = r.data.data.total;
        })
        .catch((e) => {
          this.loading = false;
          this.parseError(e);
        });
    },
    fetchLists() {
      this.$http
        .get(`/app/general/integrity-pact/list`)
        .then((r) => {
          this.loading = false;
          this.lists = r.data.data.lists;
        })
        .catch((e) => {
          this.loading = false;
          this.parseError(e);
        });
    },
  },
  filters: {
    format(date) {
      moment.locale("id");
      return moment(date).format("LL") + " " + moment(date).format("LTS");
    },
    fromNow(date) {
      moment.locale("id");
      return moment(date).fromNow();
    },
  },
};
</script>